import { NgModule } from '@angular/core';
import { LoginComponent } from 'app/core/authorization/login/login.component';

@NgModule({
  declarations: [LoginComponent],
  exports: [LoginComponent],
})
export class LoginModule {}
